import React, {useState} from 'react'
import {fireEvent} from 'react-app-events'
import useOnEvent from 'react-app-events/lib/useOnEvent'
import SessionContext from '@helpers/auth/SessionContext'

import getJWTSavedData from './apollo/getJWTSavedData'

export default function SessionContextProvider(props) {
  const jwtData = getJWTSavedData()

  const [session, setSession] = useState(jwtData)

  useOnEvent('saveSession', async newSession => {
    setSession(newSession)

    if (newSession?.userId) {
      fireEvent('saveAmplitudeSession', newSession || {})
    }
  })

  return <SessionContext.Provider value={session || {}}>{props.children}</SessionContext.Provider>
}
